// extracted by mini-css-extract-plugin
export default {"patientChartContainer":"PatientChartPage_patientChartContainer__-Ic2q"};